module.exports = __webpack_public_path__ + "img/2_250.9fe08144.png";